import * as mutation_types from '../mutation-types';

const state = {
    editingActive: {
        id: null,
        type: null,
    },
};

const mutations = {
    [mutation_types.AP_EDITING_ACTIVE_SET] (state, obj) {
        Vue.set(state, 'editingActive', Object.assign({}, obj));
    }
};

const getters = {
    AP_EDITING_ACTIVE_GET: (state) => !!state.editingActive.id,
};

export default {
    state,
    mutations,
    getters,
}